// The key in the RESPONSE header that contains the user's auth key when we log the user in. This is also the key will add to the REQUEST
// header when we make API call to CSApi after the user is logged in
export const XSRF_GUARD_KEY = 'X-Xsrf-Guard';
export var MODEMetricTypes;
(function (MODEMetricTypes) {
    // PROJECT METRICS
    MODEMetricTypes["ALL"] = "all";
    MODEMetricTypes["ALL_BYTES"] = "all_bytes";
    MODEMetricTypes["D_IN"] = "d_in";
    MODEMetricTypes["D_IN_BYTES"] = "d_in_bytes";
    MODEMetricTypes["D_OUT"] = "d_out";
    MODEMetricTypes["D_OUT_BYTES"] = "d_out_bytes";
    MODEMetricTypes["U_IN"] = "u_in";
    MODEMetricTypes["U_IN_BYTES"] = "u_in_bytes";
    MODEMetricTypes["U_OUT"] = "u_out";
    MODEMetricTypes["U_OUT_BYTES"] = "u_out_bytes";
    MODEMetricTypes["M"] = "m";
    MODEMetricTypes["M_BYTES"] = "m_bytes";
    MODEMetricTypes["O_IN"] = "o_in";
    MODEMetricTypes["O_IN_BYTES"] = "o_in_bytes";
    MODEMetricTypes["O_OUT"] = "o_out";
    MODEMetricTypes["O_OUT_BYTES"] = "o_out_bytes";
    MODEMetricTypes["AD"] = "ad";
    // TSDB SMART MODULE
    MODEMetricTypes["SS"] = "ss";
    MODEMetricTypes["SS_A"] = "ss_a";
    MODEMetricTypes["C"] = "c";
    MODEMetricTypes["C_A"] = "c_a";
    MODEMetricTypes["C_DP"] = "c_dp";
    MODEMetricTypes["TS"] = "ts";
    MODEMetricTypes["TS_A"] = "ts_a";
    MODEMetricTypes["TS_DP"] = "ts_dp";
    MODEMetricTypes["IN"] = "in";
    MODEMetricTypes["IN_BYTES"] = "in_bytes";
    MODEMetricTypes["OUT"] = "out";
    MODEMetricTypes["OUT_BYTES"] = "out_bytes";
    // SDS Module
    MODEMetricTypes["ST"] = "st";
    MODEMetricTypes["ST_BYTES"] = "st_bytes";
})(MODEMetricTypes || (MODEMetricTypes = {}));
// MetricScopeTypes enum represents different query scopes for the PUT API.
export var MetricScopeTypes;
(function (MetricScopeTypes) {
    MetricScopeTypes["PROJECT"] = "project";
    MetricScopeTypes["PROJECT_AGGREGATE"] = "projectAggregate";
    MetricScopeTypes["SMART_MODULE_ID"] = "smartModuleId";
    MetricScopeTypes["SMART_MODULE_TYPE"] = "smartModuleType";
    MetricScopeTypes["SYSTEM"] = "system";
})(MetricScopeTypes || (MetricScopeTypes = {}));
// MetricAggregationTypes enum represents different aggregation types for the PUT API.
export var MetricAggregationTypes;
(function (MetricAggregationTypes) {
    MetricAggregationTypes["METRICS_AGG_SUM"] = "sum";
    MetricAggregationTypes["METRICS_AGG_AVG"] = "avg";
    MetricAggregationTypes["METRICS_AGG_MIN"] = "min";
    MetricAggregationTypes["METRICS_AGG_MAX"] = "max";
})(MetricAggregationTypes || (MetricAggregationTypes = {}));
/**
 * Data structure for a Mode project account type
 */
export var UserAccountMode;
(function (UserAccountMode) {
    UserAccountMode["EMAIL"] = "email";
    UserAccountMode["PHONE"] = "phone";
    UserAccountMode["BYOU"] = "byou";
})(UserAccountMode || (UserAccountMode = {}));
/**
 * Define the set of Message log levels
 */
export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["ERROR"] = 0] = "ERROR";
    LogLevel[LogLevel["WARN"] = 1] = "WARN";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["DEBUG"] = 3] = "DEBUG";
})(LogLevel || (LogLevel = {}));
/**
 * The list of user who can make changes to the project
 */
export var MessageLogCallerType;
(function (MessageLogCallerType) {
    MessageLogCallerType["AGENT"] = "agent";
    MessageLogCallerType["USER"] = "user";
    MessageLogCallerType["DEVICE"] = "device";
    MessageLogCallerType["OPERATOR"] = "operator";
    MessageLogCallerType["DEVELOPER"] = "developer";
    MessageLogCallerType["PROJECT"] = "projectKey";
})(MessageLogCallerType || (MessageLogCallerType = {}));
/**
 * All the possible types of target.
 */
export var MessageLogTagType;
(function (MessageLogTagType) {
    MessageLogTagType["PROJECT"] = "p";
    MessageLogTagType["USER"] = "u";
    MessageLogTagType["HOME"] = "h";
    MessageLogTagType["DEVICE"] = "d";
    MessageLogTagType["AGENT"] = "a";
    MessageLogTagType["OPERATOR"] = "o";
    MessageLogTagType["SMART_MODULE"] = "m";
    MessageLogTagType["PROJECT_KEY"] = "k";
})(MessageLogTagType || (MessageLogTagType = {}));
/**
 * The backend server where the log is created from
 */
export var MessageLogSource;
(function (MessageLogSource) {
    MessageLogSource["EPCOT"] = "epcot";
    MessageLogSource["MCRMT"] = "mcrmt";
    MessageLogSource["MAZE"] = "maze";
    MessageLogSource["RITZ"] = "ritz";
})(MessageLogSource || (MessageLogSource = {}));
/**
 * These are the http request method that the backend return. Make sure they are spelled and have
 * the same letter case as the backend. NOTE that these are not the same as the RequestMethod we
 * have defined in the front end. Even though they have the same values, we need to separate them
 * incase we decide to change the value in the RequestMethod to use lowercase.
 */
export var HttpLogMethod;
(function (HttpLogMethod) {
    HttpLogMethod["GET"] = "GET";
    HttpLogMethod["POST"] = "POST";
    HttpLogMethod["PUT"] = "PUT";
    HttpLogMethod["PATCH"] = "PATCH";
    HttpLogMethod["DELETE"] = "DELETE";
    HttpLogMethod["OPTION"] = "OPTIONS";
})(HttpLogMethod || (HttpLogMethod = {}));
/**
 * This is the list of possible log request status
 */
export var LogRequestStatus;
(function (LogRequestStatus) {
    LogRequestStatus["REQUESTED"] = "requested";
    LogRequestStatus["UPLOADING"] = "uploading";
    LogRequestStatus["CANCELLED"] = "cancelled";
    LogRequestStatus["FAILURE"] = "failure";
    LogRequestStatus["SUCCESS"] = "success";
    LogRequestStatus["NOLOGS"] = "nologs";
})(LogRequestStatus || (LogRequestStatus = {}));
/**
 * Interfaces for Organization feature
 */
export const DEFAULT_ORGANIZATION_ID = 'default';
export var PasswordExpirationPolicy;
(function (PasswordExpirationPolicy) {
    PasswordExpirationPolicy["WARN"] = "warn";
    PasswordExpirationPolicy["BLOCK"] = "block";
})(PasswordExpirationPolicy || (PasswordExpirationPolicy = {}));
/* *************   End Interfaces for Organization feature    **************** */
